const log = {
    path: '/noti',
    name: 'journal',
    icon: 'iconnews-fill',
    redirect: '/noti/notification',
    component: () => import('@/pages/layout/appMain'),
    children: [
        //通知日志
        {
            icon: 'el-icon-c-scale-to-original',
            name: 'noticelog',
            path: '/notification',
            component: () => import('@/pages/journal/notification')
        },
        //系统日志
        {
            icon: 'el-icon-document-copy',
            name: 'sysLog',
            path: '/sysLog',
            component: () => import('@/pages/journal/sysLog.vue')
        },
        // 报警开关日志
        {
            icon: 'el-icon-bell',
            name: 'alarmLog',
            path: '/alarmLog',
            component: () => import('@/pages/journal/alarmLog.vue')
        }
    ]
};

export default log;
